import React, {useState, forwardRef, useImperativeHandle, useMemo} from 'react';
import set from 'lodash.set';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';
import Bank from './form-sections/Bank';
import Paypal from './form-sections/Paypal';
import Payout from './form-sections/Payout';
import {Button, getMessage, Message} from 'epic-diesel-common';
import {priority, buttonTypes} from 'epic-diesel-common/src/constants';
import {OfflinePaymentInfo, GatewayType} from '../../../../../shared/types/payout/PayoutPublic';
import {OfflinePaymentProps} from './OfflinePayment';
import getInfluencerSchema from '../../../../data/formsy';

//@ts-ignore
import styles from './OfflinePayment.pcss';

export interface OfflinePaymentFormProps extends OfflinePaymentProps {
    disabled: boolean;
    ref: any;
    submitForm: (model: OfflinePaymentInfo) => void;
}

export interface FormRef {
    setForm: (model: OfflinePaymentInfo) => void;
}

export const initialState: OfflinePaymentInfo = {
    gatewayType: GatewayType.PAYPAL
};

const OfflinePaymentForm = forwardRef(
    (props: OfflinePaymentFormProps, formRef: React.Ref<FormRef>) => {
        const [form, setForm] = useState(() => initialState);

        const schema = useMemo(
            () => getInfluencerSchema(getMessage, props.messages).payoutSchema(),
            []
        );

        const trigger = (name: string, value: string) => {
            const formData = {...form};
            setForm(set(formData, name, value));
        };

        function submitForm(model) {
            const requestData = {...model};
            if (form && form.id) {
                set(requestData, 'id', form.id);
            }
            if (props.submitForm) {
                props.submitForm(requestData);
            }
        }

        useImperativeHandle(formRef, () => ({setForm}));

        return (
            <FormsyForm
                // to resolve the issues on displaying error after update offline payment with type 'bank'
                key={form.modifiedAt || 'offline.payment.form'}
                className={styles.settingSection}
                ref={formRef}
                submitForm={submitForm}
                callbackDelay={2000}>
                <Payout
                    gatewayType={form.gatewayType}
                    trigger={trigger}
                    disabled={props.disabled}
                />

                {form.gatewayType === GatewayType.WIRE_TRANSFER ? (
                    <Bank
                        messages={props.messages}
                        form={form}
                        trigger={trigger}
                        disabled={props.disabled}
                        schema={schema}
                    />
                ) : (
                    <Paypal
                        messages={props.messages}
                        accountEmail={form.accountEmail}
                        trigger={trigger}
                        disabled={props.disabled}
                        schema={schema}
                    />
                )}

                {!props.disabled && (
                    <>
                        <Button type={buttonTypes.SUBMIT} priority={priority.PRIMARY} theme="dark">
                            <Message code="epic.affiliate.common.submit" />
                        </Button>
                    </>
                )}
            </FormsyForm>
        );
    }
);

export default OfflinePaymentForm;
